function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M575 0H0v24c17.992 0 26.988-4.4 35.983-8.8 8.994-4.399 17.987-8.798 35.972-8.798 17.992 0 26.987 4.4 35.982 8.8 8.994 4.4 17.987 8.798 35.972 8.798 17.993 0 26.988-4.4 35.983-8.8 8.994-4.399 17.987-8.798 35.972-8.798 17.991 0 26.986 4.4 35.982 8.8C260.842 19.6 269.837 24 287.828 24c17.993 0 26.988-4.4 35.983-8.8 8.994-4.399 17.987-8.798 35.972-8.798 17.992 0 26.988 4.4 35.983 8.8 8.993 4.4 17.987 8.798 35.971 8.798 17.987 0 26.98-4.4 35.973-8.799 8.993-4.4 17.986-8.799 35.972-8.799 17.992 0 26.988 4.4 35.983 8.8 8.887 4.347 17.773 8.693 35.335 8.796V0z",
  fill: "currentColor"
});

var SvgBgWavePhone = function SvgBgWavePhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: 24,
    viewBox: "0 0 575 24",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBgWavePhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bg_wave_phone.14d5caad.svg";
export { ForwardRef as ReactComponent };